import { IHhQueryParams as IHhQueryParamsState } from '../../types/hhQueryParams';
import { createNoopReducer } from '../../utils/redux/createNoopReducer';

const INITIAL_STATE: IHhQueryParamsState = {
  siteId: '',
  clickId: '',
};

export const hhQueryParamsReducer = createNoopReducer<IHhQueryParamsState>(INITIAL_STATE);
